module.exports = __webpack_public_path__ + "img/7.28252512.png";